import React from 'react';
import LightLogo from './light';
import DarkLogo from './dark';


const Logo = ({logoTheme}) => (logoTheme === 'Light' ? <LightLogo /> : <DarkLogo />);

export default Logo;
